import {
  localStorageStore,
  useStoredFilters,
} from 'works/legacy/lib/hooks/use-stored-filters';
import { useQuery } from '@common/hooks';
import { PaginatedStaffingRequestsList } from '@applicant-flow/graphql/queries';

type Props = {
  localStorageKey: string;
};

export function useRequestsQueryHandler({ localStorageKey }: Props) {
  const [requestFilters] = useStoredFilters<Record<string, string[]>>(
    localStorageKey,
    {
      store: localStorageStore,
    }
  );

  const {
    error: requestsError,
    data: requestsRawData,
    fetchMore: requestsFetchMore,
    loading: requestsLoading,
  } = useQuery(PaginatedStaffingRequestsList, {
    variables: {
      offset: 0,
      limit: 10,
      filters: requestFilters,
      staffingRequestTypes: ['on_demand', 'long_term'],
    },
  });

  const requestsTotal = requestsRawData?.paginatedStaffingRequests.totalCount;

  const requestsData =
    requestsRawData?.paginatedStaffingRequests?.staffingRequests || [];

  return {
    requestsLoading,
    requestsError,
    requestsData,
    requestsTotal,
    requestsFetchMore,
  };
}
